import React from 'react';

const RideSeats = ({ classDetails, handleShow }) => {
  // Divide los asientos en filas de 3, 8 y 7 asientos
  const seatsPerRow = [3, 8, 7];
  let currentIndex = 0;
  const seatRows = seatsPerRow.map((numSeats) => {
    const rowSeats = classDetails.seats.slice(currentIndex, currentIndex + numSeats);
    currentIndex += numSeats;
    return rowSeats;
  });
  const coachSeats = seatRows.shift(0);

  return (
    <>
      <div className="ride-seats">
        {/* coach and first row of seats */}
        <div className="cont-coach-seats">
          <div className={`bola-coach ${classDetails.class.type_class === 'Train' ? 'bola-roja' : ''}`}>
            {classDetails.class.coach_image ? (
              <img src={require(`../images/coaches/${classDetails.class.coach_image}`)} alt={classDetails.class.coach_name} style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'50%'}} />
            ) : (
              <span className="name-coach">{classDetails.class.coach_name ? classDetails.class.coach_name : "Coach"}</span>
            )}
          </div>

          <div className='row coach-seats'>
            {coachSeats.map((s) => (
              <div className="bola-fila" key={s.id}>
                <div 
                  onClick={() => s.status !== 1 && handleShow(s.seat_number)}
                  className={`bola-seat 
                    ${s.seat_number > 11 ? 'segunda-fila' : ''}
                    ${s.status === 1 ? 'ocupado' : ''}`
                  }
                >
                  <span>{s.seat_number}</span>
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* remaining seats */}
        <div className="seats-container">
          {seatRows.map((row, rowIndex) => (
            <div className="row" key={`row-${rowIndex}`}>
              {row.map((s) => (
                <div className="bola-fila" key={s.id}>
                  <div 
                    onClick={() => s.status !== 1 && handleShow(s.seat_number)}
                    className={`bola-seat 
                      ${s.seat_number > 11 ? 'segunda-fila' : ''}
                      ${s.status === 1 ? 'ocupado' : ''}`
                    }
                  >
                    <span>{s.seat_number}</span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default RideSeats;
